import React from "react";
import { NavLink } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import logoF from "../asset/LogoBlanc.webp";
import { useSelector } from "react-redux";

/**
 * @module Components/Footer
 * @description Footer est un composant qui affiche le pied de page de l'application.
 * Il contient des informations de contact, un logo et des liens vers les pages "Mentions légales" et "CGU".
 * Il affiche également l'année actuelle.
 */

const Footer = () => {
  const year = new Date().getFullYear();
  const token = useSelector((state) => state.user.token);

  return (
    <footer className="bg-primary text-white py-8 px-4 md:px-6 lg:px-8">
      <div className="container-responsive">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          {/* Logo */}
          <div className="flex justify-center md:justify-start">
            <img 
              src={logoF} 
              alt="Logo CCPM" 
              className="h-24 w-auto object-contain" 
            />
          </div>
          
          {/* Liens utilisateur connecté */}
          {token && (
            <div className="text-center md:text-left">
              <h3 className="text-lg font-semibold mb-4 text-white">
                <i className="fas fa-user mr-2"></i>
                Mon espace
              </h3>
              <ul className="space-y-3">
                <li>
                  <NavLink 
                    to="/Profil" 
                    className="nav-link text-white hover:text-gray-300 transition-colors duration-300 flex items-center justify-center md:justify-start"
                  >
                    <i className="fas fa-user mr-2"></i>
                    Mon compte
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink 
                    to="/ContactForm" 
                    className="nav-link text-white hover:text-gray-300 transition-colors duration-300 flex items-center justify-center md:justify-start"
                  >
                    <i className="fas fa-pencil-alt mr-2"></i>
                    Référencer une marque
                  </NavLink>
                </li>
                <li>
                  <NavLink 
                    to="/ContactForm" 
                    className="nav-link text-white hover:text-gray-300 transition-colors duration-300 flex items-center justify-center md:justify-start"
                  >
                    <i className="fas fa-envelope mr-2"></i>
                    Contact
                  </NavLink>
                </li> */}
              </ul>
            </div>
          )}

          {/* Liens légaux */}
          <div className="text-center md:text-left">
            <h3 className="text-lg font-semibold mb-4 text-white">
              <i className="fas fa-file-alt mr-2"></i>
              Documents légaux
            </h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href="/MentionsLegales.docx" 
                  download="MentionsLegales.docx" 
                  className="nav-link text-white hover:text-gray-300 transition-colors duration-300 flex items-center justify-center md:justify-start"
                >
                  <i className="fas fa-file-alt mr-2"></i>
                  Mentions légales
                </a>
              </li>
              <li>
                <a 
                  href="/CGUCCPM.docx" 
                  download="CGUCCPM.docx" 
                  className="nav-link text-white hover:text-gray-300 transition-colors duration-300 flex items-center justify-center md:justify-start"
                >
                  <i className="fas fa-file-contract mr-2"></i>
                  CGU
                </a>
              </li>
              <li>
                <a 
                  href="/CGVCCPM.docx" 
                  download="CGVCCPM.docx" 
                  className="nav-link text-white hover:text-gray-300 transition-colors duration-300 flex items-center justify-center md:justify-start"
                >
                  <i className="fas fa-file-signature mr-2"></i>
                  CGV
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-white border-opacity-20 pt-6 text-center">
          <p className="text-white text-sm">
            © {year} par <span className="font-semibold">Ça, c'est pour Moi !</span>. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
